import React from "react";
import { SDLCMetadataTypeGuards } from "@sscs/types";
import { FilterBar, Menu, SearchBar, Select, Switch } from "@sscs/ui";
import { CommonListFilter, LicenseFamilyFilter, VerifiedFilter, } from "../../../common";
import { useReportSelector } from "../../../hooks";
import { DEPENDENCY_LINKING_TO_LONG_TEXT, isFilteredByLink, } from "../../../utils";
import { selectFilteredByLink } from "../../store/dependenciesSlice";
import { initFilter } from "../utils";
import styles from "./filter.module.scss";
const Filter = ({ filter, publishers, onChange, }) => {
    const filteredByLink = useReportSelector(selectFilteredByLink);
    return (React.createElement(FilterBar, { filters: [
            {
                id: "dependency-name",
                row: 1,
                control: (React.createElement(SearchBar, { id: "dependency-name-search", value: filter.dependencyName, onChange: (name) => onChange({ ...filter, dependencyName: name }), label: "Regex search for dependency name", slotProps: { htmlInput: { maxLength: 256 } }, className: styles["dependency-name"], "data-filtered-by-link": isFilteredByLink(filter, initFilter, "dependencyName", filteredByLink) })),
            },
            {
                id: "linking",
                row: 2,
                control: (React.createElement(Select, { label: "Filter by linking type", id: "linking-type-filter", labelId: "linking-type-filter-label", displayEmpty: true, shrinkLabel: true, value: filter.linking, onChange: (value) => {
                        if ((SDLCMetadataTypeGuards.stringIsDependencyLinking(value) &&
                            value !== "package") ||
                            SDLCMetadataTypeGuards.stringIsSoftwareScenario(value) ||
                            value === "ALL")
                            onChange({ ...filter, linking: value });
                    }, className: styles.linking, "data-filtered-by-link": isFilteredByLink(filter, initFilter, "linking", filteredByLink) },
                    React.createElement(Menu.Item, { id: "show-all-types", value: "ALL" }, "Show all linking types"),
                    React.createElement(Menu.Item, { id: "filter-by-dynamic", value: "dynamic" }, DEPENDENCY_LINKING_TO_LONG_TEXT.dynamic),
                    React.createElement(Menu.Item, { id: "filter-by-static", value: "static" }, DEPENDENCY_LINKING_TO_LONG_TEXT.static),
                    React.createElement(Menu.Item, { id: "filter-by-release", value: "release" },
                        "Release ",
                        DEPENDENCY_LINKING_TO_LONG_TEXT.package),
                    React.createElement(Menu.Item, { id: "filter-by-develop", value: "develop" },
                        "Develop ",
                        DEPENDENCY_LINKING_TO_LONG_TEXT.package))),
            },
            {
                id: "publisher",
                row: 2,
                control: (React.createElement(CommonListFilter, { id: "publisher-filter", value: filter.publisher, filterName: "Publisher", options: publishers.map((publisher) => ({
                        id: publisher,
                        value: publisher,
                    })), onChange: (_event, value) => onChange({
                        ...filter,
                        publisher: value,
                    }) })),
            },
            {
                id: "verified",
                row: 2,
                control: (React.createElement(VerifiedFilter, { id: "verified-filter", allItemsLabel: "Show all dependencies", value: filter.matches, onChange: (value) => onChange({
                        ...filter,
                        matches: value,
                    }), onClear: () => onChange({ ...filter, matches: initFilter.matches }) })),
            },
            {
                id: "licenses",
                row: 2,
                control: (React.createElement(LicenseFamilyFilter, { id: "license-family-filter", value: filter.license, onChange: (value) => onChange({ ...filter, license: value }), className: styles.licenses, "data-filtered-by-link": isFilteredByLink(filter, initFilter, "license", filteredByLink) })),
            },
            {
                id: "malicious",
                row: 2,
                fit: true,
                control: (React.createElement(Switch, { title: "Filter dependencies", label: "Malicious", checked: filter.maliciousOnly, onChange: (event) => onChange({ ...filter, maliciousOnly: event.target.checked }), className: isFilteredByLink(filter, initFilter, "maliciousOnly", filteredByLink)
                        ? styles.highlight
                        : undefined })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map